import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as n from "react";
import { useState as D, useId as G, useEffect as L } from "react";
import { W as M } from "../index-PMSPXTub.js";
import { u as z } from "../index-DoOsnuB6.js";
import { P as S, c as A } from "../index-D8UDu4KA.js";
import { a as K, c as I } from "../index-eoE_jzLb.js";
import { u as q } from "../index-BZPx6jYI.js";
import { u as T } from "../index-4vbonZJj.js";
import { P as X } from "../index-CRtCLpV2.js";
import { c as j } from "../clsx-OuTLNxxd.js";
import { L as F } from "../Label-B9Ttm_DE.js";
import '../Checkbox.css';var E = "Checkbox", [W] = A(E), [$, J] = W(E), w = n.forwardRef(
  (e, s) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: h,
      defaultChecked: c,
      required: d,
      disabled: a,
      value: f = "on",
      onCheckedChange: b,
      form: p,
      ...v
    } = e, [l, C] = n.useState(null), y = z(s, (r) => C(r)), _ = n.useRef(!1), R = l ? p || !!l.closest("form") : !0, [m = !1, P] = K({
      prop: h,
      defaultProp: c,
      onChange: b
    }), H = n.useRef(m);
    return n.useEffect(() => {
      const r = l == null ? void 0 : l.form;
      if (r) {
        const x = () => P(H.current);
        return r.addEventListener("reset", x), () => r.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g($, { scope: t, state: m, disabled: a, children: [
      /* @__PURE__ */ i(
        S.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(m) ? "mixed" : m,
          "aria-required": d,
          "data-state": B(m),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: f,
          ...v,
          ref: y,
          onKeyDown: I(e.onKeyDown, (r) => {
            r.key === "Enter" && r.preventDefault();
          }),
          onClick: I(e.onClick, (r) => {
            P((x) => u(x) ? !0 : !x), R && (_.current = r.isPropagationStopped(), _.current || r.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ i(
        Q,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: f,
          checked: m,
          required: d,
          disabled: a,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(c) ? !1 : c
        }
      )
    ] });
  }
);
w.displayName = E;
var N = "CheckboxIndicator", O = n.forwardRef(
  (e, s) => {
    const { __scopeCheckbox: t, forceMount: o, ...h } = e, c = J(N, t);
    return /* @__PURE__ */ i(X, { present: o || u(c.state) || c.state === !0, children: /* @__PURE__ */ i(
      S.span,
      {
        "data-state": B(c.state),
        "data-disabled": c.disabled ? "" : void 0,
        ...h,
        ref: s,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
O.displayName = N;
var Q = (e) => {
  const { control: s, checked: t, bubbles: o = !0, defaultChecked: h, ...c } = e, d = n.useRef(null), a = q(t), f = T(s);
  n.useEffect(() => {
    const p = d.current, v = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (a !== t && C) {
      const y = new Event("click", { bubbles: o });
      p.indeterminate = u(t), C.call(p, u(t) ? !1 : t), p.dispatchEvent(y);
    }
  }, [a, t, o]);
  const b = n.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: h ?? b.current,
      ...c,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function B(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var U = w, V = O;
const Y = "_checkbox_jxhau_32", Z = "_shouldHighlightOnChecked_jxhau_32", ee = "_checked_jxhau_32", te = "_checkboxBox_jxhau_53", oe = "_indicator_jxhau_64", ce = "_checkboxGroup_jxhau_83", k = {
  checkbox: Y,
  shouldHighlightOnChecked: Z,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: ce
}, pe = ({ children: e, className: s, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: j(k.checkboxGroup, s),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), me = ({
  checked: e,
  children: s,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: h = !0,
  ...c
}) => {
  const [d, a] = D(e), f = G();
  return L(() => {
    a(e);
  }, [e]), /* @__PURE__ */ g(
    F,
    {
      className: j(
        k.checkbox,
        {
          [k.checked]: d,
          [k.shouldHighlightOnChecked]: h
        },
        t
      ),
      "data-cxy-name": "checkbox",
      id: f,
      children: [
        /* @__PURE__ */ i(
          U,
          {
            "aria-labelledby": f,
            ...c,
            checked: d,
            className: k.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), a(b);
            },
            children: /* @__PURE__ */ i(V, { className: k.indicator, children: /* @__PURE__ */ i(M, { color: "blue", size: "xsm" }) })
          }
        ),
        s
      ]
    }
  );
};
export {
  me as Checkbox,
  pe as CheckboxGroup
};
